module.exports = __webpack_public_path__ + "img/828-44a9ca.png";